<template>
    <div @mouseenter="showPopover" @mouseleave="hidePopover">
        <div class="center">
            <slot></slot>
            <div v-show="show" class="popover-card">
                <div class="mask"></div>
                <div class="popover-arrow"></div>
                <div class="popover-content">
                    <slot name="content"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: false,
        }
    },
    methods: {
        showPopover() {
            this.show = true;
        },
        hidePopover() {
            this.show = false;
            this.$emit("hide-popover");
        }
    }
}
</script>

<style scoped lang="less">
.center {
    position: relative;
}

.popover-card {
    z-index: 9999;
    position: absolute;
    top: 58px;
    left: 50%;
    transform: translateX(-50%);
    box-shadow: #D8D8D8 0px 0px 10px;
    border-radius: 16px;
    .mask {
        position: absolute;
        top: -30px;
        height: 30px;
        width: 100%;
    }
    .popover-arrow {
        position: absolute;
        left: calc(50% - 16px);
        top: -21px;
        width: 0;
        height: 0;
        border-bottom: #fff 34px solid;
        border-left: transparent 16px solid;
        border-right: transparent 16px solid;
    }

    .popover-arrow::before {
        content: "";
        position: absolute;
        top: 0px;
        /* 调整偏移量 */
        left: -20px;
        border-left: 20px solid transparent;
        border-right: 20px solid transparent;
        border-bottom: 36px solid #D8D8D8;
        /* 边框颜色 */
        z-index: -1;
    }

    .popover-content {
        background-color: #fff;
        padding: 10px;
        border-radius: 16px;
    }
}
</style>